import React from 'react';

import { ChildrenProps } from '../../../../../utils';
import { ClassNameDecorator } from '../../../../decorators';
import { ClassInjector } from '../../../../injectors';

import './WithinBlockDecorator.scoped.scss';

const WithinBlockDecorator: ClassNameDecorator<ChildrenProps> = ({ children, className }) => {
  return (
    <ClassInjector classNames={'within-block'} oldClassName={className}>
      {children}
    </ClassInjector>
  );
};

export default WithinBlockDecorator;
